module.exports = __webpack_public_path__ + "images/grey-delay.4b95bd44fcb7528c053a59c9a3560672.png";